import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { Parametric } from '../../cliente/parametric.model';
import { Direccion } from '../../security/user/direccion.model';
import { PaisCliente } from '../../cliente/paisCliente.model';
import { Provincia } from '../../cliente/provincia.model';

@Component({
  selector: 'app-usuario-datos-direcciones',
  templateUrl: './usuario-datos-direcciones.component.html',
  styleUrls: ['./usuario-datos-direcciones.component.scss']
})
export class UsuarioDatosDireccionesComponent implements OnInit {

  @Input() direccion: Direccion;
  private provincias: Provincia[];
  PaisCliente = new PaisCliente();
  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.getProvincias();
  }

  async getProvincias() {
    this.provincias = await this.apiService.get(Provincia, Provincia.path + 'provincias/', null).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-direcciones/usuario-datos-direcciones.component.ts